export function ToRadians(degrees: number) {
    return degrees * Math.PI / 180;
}

export function ToDegrees(radians: number) {
    return radians * 180 / Math.PI;
}

/**
 * Returns angle between 2 points in radians
 */
export function AngleBetween(pointA: { x: number, y: number }, pointB: { x: number, y: number }) {
    return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x);
}
